"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
mutation updateOrganization($organization: OrganizationInput!) {
    updateOrganization(organization: $organization) {
      _id
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateOrganistion.mutation.js.map